import React from "react";
import './ComboBox.css'

function ComboBox
    (
        {
            setAttribute,
            optionsData,
            style,
            value,
            disabled,
            readOnly,
            defaultValue,
            className = 'combobox',
            onBlur
        }
    ) {
    const handleSelectChange = (lookupChanged, id) => {
        lookupChanged(id)
    }


    let isValueInOptions = false;
    if (optionsData) {
        isValueInOptions = Array.isArray(optionsData.props.children) &&
            optionsData.props.children.some(child => {
                if (Array.isArray(child)) {
                    return child.some(option => String(option.props.value) === String(value));
                }
                return child.props && String(child.props.value) === String(value);
            });
    }

    const selectedValue = isValueInOptions ? value : null;

    return (
        <select
            className={className}
            onChange={(e) => handleSelectChange(setAttribute, e.target.value)}
            value={selectedValue}
            disabled={disabled}
            readOnly={readOnly}
            style={{ ...style, cursor: 'pointer' }}
            onBlur={onBlur}
        >
            {optionsData}
        </select>
    );
}

export default ComboBox;
